import { render, staticRenderFns } from "./ResultCompatibiliteH.vue?vue&type=template&id=720026e1&"
import script from "./ResultCompatibiliteH.vue?vue&type=script&lang=js&"
export * from "./ResultCompatibiliteH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports